import { List } from 'immutable';
import MenuAnalysis from 'records/MenuAnalysis';
import BaseList from 'records/BaseList';
import Base from 'records/Base';
import { REHYDRATE } from 'redux-persist/constants';

import {
  MENU_ANALYSIS_ASYNC_ACTION_START,
  MENU_ANALYSIS_ASYNC_ACTION_ERROR,
  MENU_ANALYSIS_ASYNC_UPDATE_SUCCESS,
  MENU_ANALYSIS_UPDATE_SUCCESS,
  MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS,
  MENU_ANALYSIS_CLONE_SUCCESS,
  MENU_ANALYSIS_RESET_STATE,
} from 'actions/menuAnalysis';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [MENU_ANALYSIS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ANALYSIS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ANALYSIS_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new MenuAnalysis(action.data),
    });
  },
  [MENU_ANALYSIS_UPDATE_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS]: (state, action) => {
    let newMenuAnalysis = state.get('data').updateMenuItemsAnalysisValue(action.categoryId, action.menuItemId, action.key, action.value);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuAnalysis,
    });
  },
  [MENU_ANALYSIS_CLONE_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [MENU_ANALYSIS_RESET_STATE]: () => {
    return initialState;
  },
  [REHYDRATE]: (state, action) => {
    const menuAnalysisPayload = action.payload.menuAnalysis;
    if (menuAnalysisPayload) {
      const menuAnalysisData = new MenuAnalysis(menuAnalysisPayload.data);
      return new Base({
        loading: menuAnalysisPayload.loading,
        errorMessage: menuAnalysisPayload.errorMessage,
        data: menuAnalysisData,
      });
    }
    return state;
  },
};

export default function menuAnalysis(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
